import { take } from 'redux-saga/effects';
import {
  insertPendoScript,
  initPendo,
  insertInstanaScript,
  insertLogglyScript,
  insertArroyoScript
} from './thirdPartyLibs';
import { SAVE_ANNOTATIONS } from '../initializeEreader/actions';

function* handleThirdPartyLibs(readingConfig) {
  console.time('handleThirdPartyLibs#handleThirdPartyLibs')
  if (!readingConfig) {
    return null;
  }

  const {
    userId,
    pendo,
    instana,
    loggly,
    arroyo,
  } = readingConfig;

  pendo && insertPendoScript(pendo);
  instana && insertInstanaScript(instana);
  loggly && insertLogglyScript(loggly);
  arroyo && insertArroyoScript(arroyo);
  console.timeEnd('handleThirdPartyLibs#handleThirdPartyLibs')
  try {
    yield take(SAVE_ANNOTATIONS)
    let reading_origin = '';
    const iframes = document.getElementsByTagName("iframe")
    for (let iframe of iframes) {
      if(iframe.id === '') {
        const accountTypeKeyVal = iframe.baseURI.split('?').find(i => i.includes('accountType='))
        if(accountTypeKeyVal) {
          const [,, value = ''] = accountTypeKeyVal.match(/^\s*([\w\\.\\-]+)\s*=\s*(.*)?\s*$/)
          if(value.toString() === 'he' || value.toString('hs')) {
            reading_origin = value
          }
        } else {
          reading_origin = 'HE'
        }
      }
    }
    yield initPendo(userId, reading_origin)
  } catch (error) {
    console.error('Failed to initialize Pendo:', error);
  }
}

export default handleThirdPartyLibs;
